import { render, staticRenderFns } from "./MRegister.vue?vue&type=template&id=a8c15c1a&"
import script from "./MRegister.vue?vue&type=script&lang=js&"
export * from "./MRegister.vue?vue&type=script&lang=js&"
import style0 from "./MRegister.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports